import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`

  html {
    box-sizing: border-box;
    font-size: 62.5%;
    // Colors
    --color-primary: #006269;
    --color-secondary: #fcf14b;
    --color-white: #ffffff;
    --color-black: #000000;
    --color-gray: #b3b3b3;
    --color-light-gray: #ebeded;
    --color-petrol: var(--color-primary);
    --color-bg: #ffffff;
    --color-text-dark: #000000;
    --color-text-light: #ffffff;
    // Fonts
    --font-primary: 'General Sans';
    --font-secondary: 'Kaleko 105 Remix';
    --font-tertiary: 'Kaleko 105';
    --font-size-xxs: 1.3rem;
    --font-size-xs: 1.4rem;
    --font-size-sm: 1.5rem;
    --font-size-base: 1.6rem;
    --font-size-md: 1.7rem;
    --font-size-lg: 1.9rem;
    --font-size-title-sm: 2.1rem;
    --font-size-title-md: 2.5rem;
    --font-weight-regular: 400;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    // Utils
    --border-radius-default: 15px;
    --line-height-default: 1.750;
    // Transition
    --transition-default: 0.3s;
    // Borders
    --border-transparent: rgba(0, 0, 0, 0.15);
    --border-light-transparent: rgba(255, 255, 255, 0.25);
    // Layouts
    --max-container-width: 1240px;
    --max-container-width-small: 800px;
    --max-container-width-medium: 1140px;
    --max-container-width-large: 1600px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    /* revert mindbodygym html styling */
    overflow-y: unset !important;
  }

  main {
    position: relative;
    padding: 0;
    z-index: 0;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    position: relative;
    padding: 0;
    margin: 0;
    min-height: 100vh;
    width: 100%;
    line-height: 1.4;
    font-family: var(--font-primary);
    background-color: var(--color-primary);
    font-size: var(--font-size-base);
    overscroll-behavior-y: none;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    line-height: 1;
  }

  h1 {
    font-family: var(--font-secondary);
    font-weight: var(--font-weight-regular);
  }

  p, ul {
    margin: 0;
    padding: 0;

    + p,
    + a,
    + h2,
    + h3,
    + h4,
    + ul {
      margin: 2.5rem 0 0;
    }
  }

  p,
  address  {
    line-height: var(--line-height-default);
  }

  address {
    font-style: normal;
  }

  a {
    color: inherit;
    text-decoration: none;
    transition: all var(--transition-default);

    &:hover {
      color: var(--color-secondary);
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  img {
    display: block;
    max-width: 100%
  }

  input {
    font-family: inherit;
  }

  .content {
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: var(--color-primary);
    z-index: 2;
  }

/* Cookiebot styling */
#CybotCookiebotDialog {
  text-transform: none;
  font-family: inherit !important;
  opacity: 0;
  animation: fromBottom 0.75s cubic-bezier(0.165, 0.84, 0.44, 1) 2s both !important;
  width: 100% !important;
  max-width: 475px !important;
  top: auto !important;
  bottom: 0 !important;
  right: 0 !important;
  left: 0 !important;
  border-radius: 8px 8px 0 0 !important;

  @media (${({ theme }) => theme.respondTo.tablet}){
    border-radius: 8px !important;
    bottom: 30px !important;
    right: 30px !important;
    left: auto !important;
    max-height: 70vh !important;
  }

  > div {
    /* remove TEST logo */
    display: none;
  }
}

#CybotCookiebotDialogHeader,
#CybotCookiebotDialogPoweredByText {
  display: none !important;
}

#CybotCookiebotDialogNav .CybotCookiebotDialogNavItemLink {
  padding: 15px 7.5px 12px !important;
  text-transform: uppercase !important;
  color: black !important;

  &[aria-selected='true'] {
    color: var(--color-primary) !important;
    border: none !important;
  }

  &:hover {
    color: var(--color-primary) !important;
  }
}

#CybotCookiebotDialogTabContent input:checked + .CybotCookiebotDialogBodyLevelButtonSlider {
  background-color: var(--color-primary) !important;
}

#CybotCookiebotDialogBodyContent {
  padding: 7.5px !important;
  line-height: 1 !important;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    padding: 25px 25px !important;
  }
}

#CybotCookiebotDialogBodyButtonsWrapper {
  @media (max-width: 480px) {
    flex-direction: unset !important;

    > * {
      margin: 0 5px 0 0 !important;
    }
  }
}

#CybotCookiebotDialogBodyContentTitle {
  font-size: 18px !important;
}

#CybotCookiebotDialogBodyContentText {
  font-size: 15px !important;
  font-weight: normal;
}
#CybotCookiebotDialogTabContent .CybotCookiebotDialogTabPanel {
  font-weight: normal !important;
}

#CybotCookiebotDialogBodyLevelButtonsSelectPane .CybotCookiebotDialogBodyLevelButtonWrapper {
  padding: 5px 10px 10px !important;

  @media (max-width: 480px) {
    width: 50% !important;
  }
}

#CybotCookiebotDialog .CybotCookiebotScrollContainer {
  @media (max-width: 480px) {
    min-height: 0 !important;
  }
}

#CybotCookiebotDialogBodyLevelButtonsSelectPane {
  @media (max-width: 480px) {
    padding: 7.5px 0 0 !important;
  }
}

#CybotCookiebotDialogBodyLevelButtonsSelectPane .CybotCookiebotDialogBodyLevelButtonDescription {
  font-weight: normal !important;
}

#CybotCookiebotDialogTabContent .CybotCookiebotDialogBodyLevelButtonSliderWrapper {
  height: 24px !important;
  width: 40px !important;
}

#CybotCookiebotDialogTabContent .CybotCookiebotDialogBodyLevelButtonSlider:before {
  height: 16px !important;
  width: 16px !important;
}

#CybotCookiebotDialogTabContent input:checked + .CybotCookiebotDialogBodyLevelButtonSlider:before {
  transform: translateX(16px) !important;
}

#CybotCookiebotDialogTabContent .CybotCookiebotDialogBodyLevelButtonSlider {
  background-color: rgb(20 20 20 / 28%) !important;
}

.CybotCookiebotDialogBodyButton {
  background: var(--color-primary) !important;
  border: none !important;
  padding: 10px 5px !important;
  color: white !important;
  font-size: 11px !important;

  @media (${({ theme }) => theme.respondTo.tablet}){
    font-size: 14px !important;
  }

  &:hover {
    color: white !important;
  }
}

.CybotCookiebotDialogDetailBodyContentCookieContainerButton:hover {
  color: #ff62be !important;
}

#CybotCookiebotDialog .CookieCard .CybotCookiebotDialogDetailBodyContentCookieTypeIntro {
  padding: 0 !important;
}

#CybotCookiebotDialogBodyLevelButtonsSelectPane .CybotCookiebotDialogBodyLevelButtonLabel {
  margin-bottom: 2.5px !important;
}

@keyframes fromBottom {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

`;

export default GlobalStyle;
